<template>
  <v-tooltip bottom color="#2C2C2C">
    <template v-slot:activator="{ on, attrs }">
      <div class="chart__item" v-bind="attrs" v-on="on">
        <div>
          <div class="chart__item__text chart__item__text_wait f12">
            {{
              work.is_extra === 1 || work.planned === 0
                ? ''
                : work.is_hourly === 0
                  ? $roundNumberToTenths(work.planned) + ' ' + work.measure
                  : $formatTime(work.planned)
            }}
          </div>
          <div v-if="work.done > work.planned && !(work.is_extra === 1 || work.planned === 0)" class="chart__item__text chart__item__text_overdone overdone mt-1 f8">
            (+{{
              work.is_hourly === 0
                ? $roundNumberToTenths(work.done - work.planned) + ' ' + work.measure
                : $formatTime(work.done - work.planned)
            }})
          </div>
        </div>
        <div
          class="chart__item__box"
          :style="{
            height: onPercentageOfTheMax(work.done > work.planned ? work.done : work.planned),
          }"
        >
          <div
            class="chart__item__box_wait"
            :style="{
              height: work.done > work.planned ? '0%' : onPercentageWait(work.planned, work.done),
            }"
          />
          <div
            class="chart__item__box_ready"
            :style="{
              height:
                work.done > work.planned ? '100%' : onPercentageReady(work.planned, work.done),
            }"
          />
        </div>
        <div class="chart__item__text chart__item__text_ready f12">
          {{
            work.done
              ? work.is_hourly === 0
                ? $roundNumberToTenths(work.done) + ' ' + work.measure
                : $formatTime(work.done)
              : work.is_hourly === 0
              ? '0 ' + work.measure
              : $formatTime(work.done)
          }}
        </div>
      </div>
    </template>
    <span class="tooltip__text"
      >{{ work.work_type.name }}<br />
      <!-- {{
                formatDate(work.start_date) + ' - ' + formatDate(work.end_date)
            }} -->
    </span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'TimeControlCardChartItem',
  props: ['work', 'mathMaxWorkSize'],
  data() {
    return {}
  },
  components: {},
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
  },
  methods: {
    onPercentageOfTheMax(size) {
      let result = 200 * (((size / this.mathMaxWorkSize) * 100) / 100)
      return ((result > 5 ? result : result == 0 || !result ? 200 : 5) + 'px').toString()
    },
    onPercentageWait(sizeAll, sizeReady) {
      let result = ((sizeAll - sizeReady) / sizeAll) * 100
      return (result + '%').toString()
    },
    onPercentageReady(sizeAll, sizeReady) {
      return ((sizeReady / sizeAll) * 100 + '%').toString()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
  },
}
</script>

<style lang="scss" scoped>
.chart {
  &__item {
    width: 100%;
    min-width: 70px;
    max-width: 50%;
    display: grid;
    align-self: flex-end;
    height: max-content;
    gap: 10px;
    z-index: 1;
    &__text {
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      width: 100%;
      &_wait {
        color: #f2994a;
        min-height: 12px;
      }
      &_ready {
        color: #0d9d2c;
        min-height: 12px;
      }
      &_overdone {
        color: #EB5757;
        min-height: 12px;
      }
    }
    &__box {
      &_wait {
        background: #f2994a;
      }
      &_ready {
        background: #0d9d2c;
      }
    }
  }
}
</style>
